import { Image, Notes } from "mdx-deck";
import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, vsDark } from "@code-surfer/themes";
import todoList from "../../../../../../images/todo-list.gif";
import citiesList from "../../../../../../images/cities-list.gif";
import React from 'react';
export default {
  Image: Image,
  Notes: Notes,
  CodeSurfer: CodeSurfer,
  CodeSurferColumns: CodeSurferColumns,
  Step: Step,
  github: github,
  vsDark: vsDark,
  todoList: todoList,
  citiesList: citiesList,
  React: React
};